// extracted by mini-css-extract-plugin
export var clickableParagraph = "hr_qf";
export var tooltip = "hr_dn";